import { track } from '@mc/track-event'

interface FaqTrackProps {
  eventType: string
  pageSource: string
  question: string
}

export const trackFaq = ({
  eventType,
  pageSource,
  question,
}: FaqTrackProps) => {
  if (eventType && pageSource && question) {
    track(eventType, {
      category: 'faq',
      action: `FAQ:${question}`,
      page_source: pageSource,
      location: 'FAQ section',
      page_path: window.location.pathname,
    })
  }
}
